export default __webpack_public_path__ + "static/media/view-icon-24.53e54c03.svg";